import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FEATURE_ID, ROUTE } from '../Common/constant';

const BreadCrumb = () => {
    const location = useLocation();
    const navigate = useNavigate()
    const pathnames = location.pathname.split('/').filter((x) => x);

    const newsArticlesRoutes = [
        ROUTE.NEWS.BASE_URL,
        ROUTE.ARTICLES.BASE_URL
    ]

    const formattedPathname = (pathname) => {
        const clearPath = pathname.replace(/[^a-zA-Z0-9]/g, " ")
        if (clearPath.length <= 30) {
            return clearPath;
        }
        return clearPath.substring(0, 27) + '...';
    }

    const onNavigate = (path) => {
        if (path === ROUTE.NEWS.BASE_URL) {
            navigate(ROUTE.NEWS_ARTICLES, { state: FEATURE_ID.NEWS })
        } else if (path === ROUTE.ARTICLES.BASE_URL) {
            navigate(ROUTE.NEWS_ARTICLES, { state: FEATURE_ID.ARTICLE })
        } else {
            navigate(path)
        }
    }

    const getLink = (path) => {
        if (newsArticlesRoutes.includes(path)) return ""
        return path
    }

    return (
        <section className="p_relative">
            <div className="auto-container">
                <div className="content__box p_relative">
                    <ul className="bread__crumb">
                        <li><Link to={ROUTE.BASE_URL}>Home</Link></li>
                        {pathnames.map((name, index) => {
                            const link = `/${pathnames.slice(0, index + 1).join('/')}`
                            return (
                                <li key={name}>
                                    <i className='icon-05'></i>
                                    <button onClick={() => onNavigate(link)}>{formattedPathname(name)}</button>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default BreadCrumb;
